import Cookie from "./Cookie";

export function getCurrencySymbol(){
	const currency = Cookie.get("currency");
	if(currency)
		return currency;
	return "Rs"
}



// WEBPACK FOOTER //
// ./src/util/currency.js